import { defineStore, acceptHMRUpdate } from 'pinia';
import { fetchConfig } from '@/stores/api/config.api';

interface ConfigState {
    isProduction: boolean;
    hosts: Record<string, unknown>;
    insertBackendDomainName: string | null;
    fetching: boolean;
    error: unknown;
}

export function getInitialState (): ConfigState {
    return {
        isProduction: false,
        hosts: {},
        insertBackendDomainName: null,
        fetching: false,
        error: null,
    };
}

export const useConfigStore = defineStore('config', {
    state: getInitialState,
    actions: {
        setConfig (config: Partial<ConfigState>) {
            Object.assign(this.$state, config);
        },
        setFetching (fetching: boolean) {
            this.fetching = fetching;
        },
        setError (error: unknown) {
            this.error = error;
        },
        init () {
            this.getConfig();
        },
        async getConfig () {
            try {
                this.setFetching(true);
                const config = await fetchConfig();
                this.setConfig(config);
                this.setFetching(false);
            } catch (error) {
                this.setError(error);
                this.setFetching(false);
            }
        },
    },
});

if (module.hot) {
    module.hot.accept(acceptHMRUpdate(useConfigStore, module.hot));
}
